/**
 * Copyright Highway9 Networks Inc.
 */

import { DataObject } from "./dataObject";
import { BitRate } from "./deviceGroup";

export interface IDNN extends DataObject {
  ambr: BitRate;
  defaultQci: number;
  name: string;
  docVersion?: number;
  runtimeInfo?: string;
  /** PLMN components when present on subscriber network payloads */
  mcc?: string;
  mnc?: string;
}

export const defaultDNN: IDNN = {
  ambr: {
    uplink: 4000000000,
    downlink: 4000000000
  },
  defaultQci: 9,
  name: ""
}